<app-page-body [class]="'wpd-container-body wpd-header-area'">
  <app-page-header
    custom-header
    [title]="'pages.landingPage.title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    [showRefreshBtn]="false"
  >
    <div class="card-toolbar" after-btns>
      <!-- <div class="short-url">
        {{ "pages.landingPage.ShortLinkAddress" | translate }}
        <a [href]="shortUrl" target="_blank">
          <span class="link txt-lg text-light">
            <i class="mdi mdi-web tw-mx-2"></i>
            {{ shortUrl }}
          </span>
        </a>
      </div> -->

      <!-- create or update btn -->
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        mat-ripple
        (click)="createOrUpdateLandingPage()"
        [matTooltip]="'common.save' | translate"
      >
        <i class="mdi mdi-content-save mdi-20px tw-p-0 text-navyBlue"></i>
      </a>
    </div>
  </app-page-header>
</app-page-body>

<div class="row">
  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs border-bottom tw-text-center tw-sticky tw-top-0 tw-z-[5] tw-bg-white dark:tw-bg-dark-300"
    [destroyOnHide]="false"
  >
    <!-- *desginer -->
    <ng-container [ngbNavItem]="'grapesJs'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <span class="tw-mt-1 tw-mr-2 text-dark">{{
          "pages.landingPage.desginer" | translate
        }}</span>
      </a>
      <ng-template ngbNavContent>
        <div class="rtl:tw-pr-5 ltr:tw-pl-5 tw-w-[95%]">
          <div
            class="tw-flex tw-justify-between tw-my-4 sm:tw-flex-row tw-flex-col sm:tw-items-center tw-items-end"
          >
            <!-- دکمه‌های تغییر اندازه -->
            <div
              class="sm:tw-order-1 tw-order-2 tw-flex tw-mx-4 tw-gap-2 tw-justify-center *:tw-p-2 *:tw-border *:tw-rounded *:tw-bg-white dark:*:tw-bg-gray-750 hover:*:tw-bg-gray-200 dark:hover:*:tw-bg-gray-600 dark:*:tw-border-gray-500"
            >
              <!-- 📱 mobile -->
              <button
                [matTooltip]="'pages.landingPage.previewInMobile' | translate"
                (click)="setViewSize('mobile')"
              >
                <i
                  class="mdi mdi-cellphone mdi-24px tw-text-primary-800 dark:tw-text-gray-200"
                ></i>
              </button>

              <!-- 📟 tablet -->
              <button
                [matTooltip]="'pages.landingPage.previewInTablet' | translate"
                (click)="setViewSize('tablet')"
              >
                <i
                  class="mdi mdi-tablet mdi-24px tw-text-primary-800 dark:tw-text-gray-200"
                ></i>
              </button>

              <!-- 🖥️ desktop -->
              <button
                [matTooltip]="'pages.landingPage.previewInDesktop' | translate"
                (click)="setViewSize('desktop')"
              >
                <i
                  class="mdi mdi-monitor mdi-24px tw-text-primary-800 dark:tw-text-gray-200"
                ></i>
              </button>

              <!-- 👁️ preview -->
              <button
                [matTooltip]="'common.preview' | translate"
                (click)="openLandingPagePreview()"
              >
                <i
                  class="mdi mdi-eye mdi-24px tw-text-primary-800 dark:tw-text-gray-200"
                ></i>
              </button>
            </div>

            <div class="tw-flex sm:tw-order-2 tw-order-1 sm:tw-pb-0 tw-pb-5">
              <!-- open select from template dialog box -->
              <button
                type="button"
                class="btn-primary button-shadow mat-ripple tw-flex tw-items-center tw-mx-1 tw-px-2 tw-rounded-md hover:tw-opacity-90 tw-h-14"
                [themeColor]="'btn'"
                mat-ripple
                (click)="openTemplateSelectorDialog()"
              >
                <div class="tw-flex-row tw-flex">
                  <i
                    class="mdi mdi-format-list-checks mdi-21px sm:tw-block tw-hidden"
                  ></i>
                  <span class="tw-mx-1">{{
                    pageVocabs + "selectFromTemplates" | translate
                  }}</span>
                </div>
              </button>

              <!-- open Save as Template dialog box -->
              <button
                type="button"
                class="tw-h-14 btn-info button-shadow mat-ripple tw-flex tw-items-center tw-mx-1 tw-px-2 tw-rounded-md hover:tw-opacity-90"
                [themeColor]="'btn-info'"
                mat-ripple
                (click)="showReadyTemplateSaveDialog()"
              >
                <div class="tw-flex-row tw-flex">
                  <i
                    class="mdi mdi-content-save-edit-outline mdi-21px sm:tw-block tw-hidden"
                  ></i>
                  <span class="tw-mx-1">{{
                    pageVocabs + "saveAsTemplate" | translate
                  }}</span>
                </div>
              </button>
            </div>
          </div>
          <!-- grapes js -->
          <ngx-grapes-grapesjs-editor
            [pageHtml]="pageHtml"
            (htmlChanged)="htmlCode = $event"
            (cssChanged)="editorCssCode = $event"
          />
        </div>
      </ng-template>
    </ng-container>

    <!-- *jsEditor -->
    <ng-container [ngbNavItem]="'jsEditor'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <span class="tw-mt-1 tw-mr-2 text-dark">{{
          "pages.landingPage.jsEditor" | translate
        }}</span>
      </a>
      <ng-template ngbNavContent>
        <div class="rtl:tw-pr-5 ltr:tw-pl-5 tw-w-[95%]">
          <div class="tw-flex tw-justify-between tw-my-4">
            <div></div>

            <div class="tw-flex">
              <!-- open select from template dialog box -->
              <button
                type="button"
                class="btn-primary button-shadow mat-ripple tw-flex tw-items-center tw-mx-1 tw-px-2 tw-rounded-md hover:tw-opacity-90 tw-h-14"
                [themeColor]="'btn'"
                mat-ripple
                (click)="openTemplateSelectorDialog()"
              >
                <div class="tw-flex-row tw-flex">
                  <i
                    class="mdi mdi-format-list-checks mdi-21px sm:tw-block tw-hidden"
                  ></i>
                  <span class="tw-mx-1">{{
                    pageVocabs + "selectFromTemplates" | translate
                  }}</span>
                </div>
              </button>

              <!-- open Save as Template dialog box -->
              <button
                type="button"
                class="btn-info button-shadow mat-ripple tw-flex tw-items-center tw-mx-1 tw-px-2 tw-rounded-md hover:tw-opacity-90 tw-h-14"
                [themeColor]="'btn-info'"
                mat-ripple
                (click)="showReadyTemplateSaveDialog()"
              >
                <div class="tw-flex-row tw-flex">
                  <i
                    class="mdi mdi-content-save-edit-outline mdi-21px sm:tw-block tw-hidden"
                  ></i>
                  <span class="tw-mx-1">{{
                    pageVocabs + "saveAsTemplate" | translate
                  }}</span>
                </div>
              </button>
            </div>
          </div>
          <!-- js  -->
          <app-monaco-editor
            [(code)]="jsCode"
            lang="javascript"
          ></app-monaco-editor>
        </div>
      </ng-template>
    </ng-container>

    <!-- *cssEditor -->
    <ng-container [ngbNavItem]="'cssEditor'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <span class="tw-mt-1 tw-mr-2 text-dark">{{
          "pages.landingPage.cssEditor" | translate
        }}</span>
      </a>

      <ng-template ngbNavContent>
        <div class="rtl:tw-pr-5 ltr:tw-pl-5 tw-w-[95%]">
          <div class="tw-flex tw-justify-between tw-my-4">
            <div></div>

            <div class="tw-flex">
              <!-- open select from template dialog box -->
              <button
                type="button"
                class="btn-primary button-shadow mat-ripple tw-flex tw-items-center tw-mx-1 tw-px-2 tw-rounded-md hover:tw-opacity-90 tw-h-14"
                [themeColor]="'btn'"
                mat-ripple
                (click)="openTemplateSelectorDialog()"
              >
                <div class="tw-flex-row tw-flex">
                  <i
                    class="mdi mdi-format-list-checks mdi-21px sm:tw-block tw-hidden"
                  ></i>
                  <span class="tw-mx-1">{{
                    pageVocabs + "selectFromTemplates" | translate
                  }}</span>
                </div>
              </button>

              <!-- open Save as Template dialog box -->
              <button
                type="button"
                class="btn-info button-shadow mat-ripple tw-flex tw-items-center tw-mx-1 tw-px-2 tw-rounded-md hover:tw-opacity-90 tw-h-14"
                [themeColor]="'btn-info'"
                mat-ripple
                (click)="showReadyTemplateSaveDialog()"
              >
                <div class="tw-flex-row tw-flex">
                  <i
                    class="mdi mdi-content-save-edit-outline mdi-21px sm:tw-block tw-hidden"
                  ></i>
                  <span class="tw-mx-1">{{
                    pageVocabs + "saveAsTemplate" | translate
                  }}</span>
                </div>
              </button>
            </div>
          </div>
          <!-- css  -->
          <app-monaco-editor [(code)]="cssCode" lang="css"></app-monaco-editor>
        </div>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
</div>
